import { getBrowserLocale } from '@/services/i18n';
import { createBEMClasses } from '@/utils/classname';

import './CountBadge.css';

const { block } = createBEMClasses('count-badge');

interface CountBadgeProps {
  count: number;
  /**
   * - 99+: If count > 99, display 99+
   * - 1k: If count > 999, display 1k, 1.2k, 3.7k...
   */
  countFormat?: '99+' | '1k';
  variant?: 'default' | 'neutral';
  size?: 'small' | 'medium';
  isActive?: boolean;
}

export const CountBadge = ({
  count,
  countFormat = '99+',
  variant = 'default',
  size = 'medium',
  isActive = true,
}: CountBadgeProps) => {
  const locale = getBrowserLocale();

  return (
    <div className={block({ variant, size, disabled: !isActive })}>
      {countFormat === '99+' && (count > 99 ? '99+' : count)}

      {countFormat === '1k' && Intl.NumberFormat(locale, { notation: 'compact' }).format(count)}
    </div>
  );
};
